// @import dependencies
import { CombinedReducers as IState } from 'app_events/index'
import React, {Component} from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import {CourseSchedulingEnrollmentScreenLayout} from 'app_components/screens/admin/courseSchedulingEnrollment'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import services
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import types
import { ICourseSchedulingEnrollmentListItem, ICourseSchedulingEnrollmentsHttpResponse, INewCourseSchedulingEnrollment } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types
interface ICourseSchedulingEnrollmentScreenProps {
  match?: any
}
interface ICourseSchedulingEnrollmentScreenState {
  status: null | 'loading' | 'error'
  courseScheduling: ICourseSchedulingListItem | null
  itemList: ICourseSchedulingEnrollmentListItem[]
  add: boolean
  edit: boolean
  view: boolean
  editData: null | ICourseSchedulingEnrollmentListItem
  selectedRow: null | string
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseSchedulingEnrollmentScreen extends Component<ICourseSchedulingEnrollmentScreenProps, ICourseSchedulingEnrollmentScreenState> {

  public moduleName: string = 'module:course_scheduling_enrollment'
  private permission: PermissionService
  private screenNotifications: ScreenNotificationsUtil
  private itemService: CourseSchedulingEnrollmentService
  private i18nUtil: I18nUtil
  private course_scheduling: any = null
  private courseSchedulingService: CourseSchedulingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseSchedulingEnrollmentScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      courseScheduling: null,
      itemList: [],
      add: false,
      edit: false,
      view: false,
      editData: null,
      selectedRow: null,
      pagination: {
        page: 1,
        perPage: 50,
        total: 0,
      },
    }

    this.permission = new PermissionService(this.moduleName)
    this.screenNotifications = new ScreenNotificationsUtil()
    this.itemService = new CourseSchedulingEnrollmentService()
    this.i18nUtil = new I18nUtil()
    this.courseSchedulingService = new CourseSchedulingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.match?.params?.course_scheduling) {
      this.course_scheduling = this.props?.match?.params?.course_scheduling
      const courseSchedulingResponse = await this.courseSchedulingService.getOne(this.course_scheduling)
      if (courseSchedulingResponse) {
        this.setState({
          courseScheduling: courseSchedulingResponse,
        }, async () => {
          await this.getList()
        })
      } else {
        this.setState({
          status: null,
        })
      }
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onRowClick = async (row: any) => {
    if (this.state.selectedRow === row._id) {
      this.setState({ selectedRow: null })
    } else {
      // this.setState({ status: 'loading' })
      const item: any = this.state.itemList.find((item) => item._id === row._id)

      if (!item?.details) {
        await this.getItem(row._id)
      }

      this.setState({
        selectedRow: row._id,
        // status: null,
      })
    }
  }

  showAddForm = async (add: boolean) => {
    this.setState({ add })
  }

  showEditForm = async (edit: boolean, register?: any) => {
    if (edit && register) {
      await this.getItem(register._id)
      this.setState({ edit: true, editData: register })
    } else {
      this.setState({ edit: false })
    }
  }

  onViewerRow = async (view: boolean, register?: any) => {
    if (view && register) {
      await this.getItem(register._id)
      this.setState({ view: true, editData: register })
    } else {
      this.setState({ view: false })
    }
  }

  onPageChange = async (page: number) => {
    this.getList({ page })
  }

  onSearch = async (event: any) => {
    this.getList({ page: 1, search: event.search })
    return false
  }

  getItem = async (id: string) => {
    // this.setState({ status: 'loading' })

    const itemIndex = this.state.itemList.findIndex((item) => item._id === id)
    const itemList: Array<any> = [...this.state.itemList]

    const item: any = await this.itemService.getOne(id)
    if (item) {
      itemList[itemIndex].details = item
    } else {
      // this.setState({ status: 'error' })
    }
  }

  getList = async (params?: any) => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      check_certification: true,
      isActive: false,
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    if (this.state.courseScheduling) {
      httpParams.course_scheduling = this.state.courseScheduling._id
    }

    let itemList: ICourseSchedulingEnrollmentsHttpResponse | null = await this.itemService.list(httpParams)

    if (itemList?.status_code === 'success') {
      this.setState({
        itemList: itemList?.enrollment,
        pagination: {
          total: itemList?.total_register,
          perPage: itemList?.nPerPage,
          page: itemList?.pageNumber,
        },
        status: null,
      })

      console.log('itemList enrollment-->')

      itemList.enrollment.forEach( e => {

        if(e.certificate){

          e.certificate.forEach( a => {
            console.log(a.certificate ) })
        }
       })

    } else {
      this.setState({ status: 'error' })
    }
  }

  addItem = async (response: any) => {
    if (response) {
      this.setState({ add: false })
      this.getList()
    }
  }

  updateItem = async (response: INewCourseSchedulingEnrollment) => {
    if (response) {
      this.setState({ edit: false })
      this.getList()
    }
  }

  removeItem = async (id: string) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('screens.course_scheduling.enrollment.delete.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('screens.course_scheduling.enrollment.delete.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          // this.setState({ status: 'loading' })

          const remove = await this.itemService.remove(id)

          if (remove) {
            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },
              {
                position: 'bottom-right',
              },
            )

            this.getList()
          }

          // this.setState({ status: null })
        }
      })
    }
  }

  massiveUpload = async () => {
    this.getList({page: 1})
  }

  certificationGenerated = async () => {
    this.getList({page: 1})
  }

  reGenerateCertifications = async () => {
    this.getList({page: 1})
  }

  updateLoadParticipantsStatus = (loading: boolean) => {
    const scheduling = this.state.courseScheduling
    if (scheduling) {
      this.setState({
        courseScheduling: {
          ...scheduling,
          loadParticipants: {
            ...scheduling?.loadParticipants,
            loading,
          },
        },
      })
    }
  }

  render() {
    return(
      <CourseSchedulingEnrollmentScreenLayout
        add={this.permission.check('permission:course_scheduling_enrollment_create', this.state.add)}
        edit={this.permission.check('permission:course_scheduling_enrollment_update', this.state.edit)}
        view={this.permission.check('permission:course_scheduling_enrollment_viewer', this.state.view)}
        editData={this.state.editData}
        onRowClick={this.onRowClick}
        onViewerRow={this.permission.check('permission:course_scheduling_enrollment_viewer', this.onViewerRow)}
        selectedRow={this.state.selectedRow}
        showAddForm={this.permission.check('permission:course_scheduling_enrollment_create', this.showAddForm)}
        showEditForm={this.permission.check('permission:course_scheduling_enrollment_update', this.showEditForm)}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        itemList={this.permission.check('permission:course_scheduling_enrollment_list', this.state.itemList)}
        addItem={this.permission.check('permission:course_scheduling_enrollment_create', this.addItem)}
        updateItem={this.permission.check('permission:course_scheduling_enrollment_update', this.updateItem)}
        removeItem={this.permission.check('permission:course_scheduling_enrollment_delete', this.removeItem)}
        onSearch={this.permission.check('permission:course_scheduling_enrollment_list', this.onSearch)}
        status={this.state.status}
        courseScheduling={this.state.courseScheduling}
        massiveUpload={this.massiveUpload}
        updateLoadParticipantsStatus={this.updateLoadParticipantsStatus}
        certificationGenerated={this.permission.check('permission:course_scheduling_enrollment_generate_certifications', this.certificationGenerated)}
        canViewCertifications={this.permission.check('permission:course_scheduling_enrollment_download_certifications', true)}
        reGenerateCertifications={this.reGenerateCertifications}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseSchedulingEnrollmentScreen)
